module.exports = __webpack_public_path__ + "img/mysales.1e1f3474.png";